import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import SortBy from "./elements/SortBy"
import MobileFilterButton from "./MobileFilterButton"
import MobileFacetsModal from "./MobileFacetsModal"
import { useState } from "preact/hooks"

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false)

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0
    const totalSummary = pageType === "category" ? `${docCount} items` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div class="facets-vertical-sort">
            <form class="facets-vertical-form" id="FacetSortForm">
                <div class="mobile-facets__details js-filter" data-index="mobile-">
                    <div class="mobile-facets__summary" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <MobileFilterButton onClick={() => setIsMobileFiltersOpen(true)} />
                        
                        {!loading && (
                            <div class="product-count light" role="status">
                                <h2 class="product-count__text text-body">
                                    <span class="Button-C" id="ProductCount">
                                        {totalSummary}
                                    </span>
                                </h2>
                                <div class="loading__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30" />
                                    </svg>
                                </div>
                            </div>
                        )}

                        <div class="mobile-facets__sort">
                            <div class="select">
                                <div class="sc-sort">
                                    <SortBy
                                        value={activeSort}
                                        onChange={handleSortChange}
                                        options={options}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <MobileFacetsModal 
                isOpen={isMobileFiltersOpen} 
                onClose={() => setIsMobileFiltersOpen(false)} 
            />
        </div>
    )
}
